<div #barcodediv id="{{ bcid }}" class="barcodediv"></div>
<div *ngIf="displayvalue" #valuediv class="valuediv">{{ code }}</div>
